// Import existing logos
import axisLogo from "../assets/axis.png";
import dspLogo from "../assets/dsp.png";
import edelweissLogo from "../assets/edelweiss.png";
import hdfcLogo from "../assets/hdfc.png";
import iciciLogo from "../assets/icici.jpeg";
import invescoLogo from "../assets/invesco.png";
import itiLogo from "../assets/iti.png";
import kotakLogo from "../assets/kotak.png";
import miraeLogo from "../assets/mirae.png";
import nipponLogo from "../assets/nippon.jpeg";
import ppfasLogo from "../assets/ppfas.jpeg";
import quantLogo from "../assets/quant.png";
import utiLogo from "../assets/uti.jpeg";
import whiteoakLogo from "../assets/whiteaok.jpeg";

// Import new logos
import abcapitalLogo from "../assets/abcapital.jpeg";
import bandhanLogo from "../assets/bandhan.jpeg";
import bnparibasLogo from "../assets/bnparibas.png";
import boimfLogo from "../assets/boimf.jpeg";
import canararobecoLogo from "../assets/canararobeco.jpeg";
import franklinLogo from "../assets/franklin.jpeg";
import jmfinancialLogo from "../assets/jmfinancial.png";
import naviLogo from "../assets/navi.png";
import sundaramLogo from "../assets/sundaram.png";
import tataLogo from "../assets/tata.png";
import unionLogo from "../assets/union.png";
import motilalLogo from "../assets/moswal.jpeg";
import sbiLogo from "../assets/sbi.png";

const logoMap = {
  // Existing mappings
  axis: axisLogo,
  dsp: dspLogo,
  edelweiss: edelweissLogo,
  hdfc: hdfcLogo,
  icici: iciciLogo,
  invesco: invescoLogo,
  iti: itiLogo,
  kotak: kotakLogo,
  mirae: miraeLogo,
  nippon: nipponLogo,
  parag: ppfasLogo,
  ppfas: ppfasLogo,
  quant: quantLogo,
  uti: utiLogo,
  whiteoak: whiteoakLogo,
  
  // New mappings
  aditya: abcapitalLogo,
  birla: abcapitalLogo,
  bandhan: bandhanLogo,
  bnp: bnparibasLogo,
  paribas: bnparibasLogo,
  "bank of india": boimfLogo,
  canara: canararobecoLogo,
  robeco: canararobecoLogo,
  franklin: franklinLogo,
  templeton: franklinLogo,
  jm: jmfinancialLogo,
  navi: naviLogo,
  sundaram: sundaramLogo,
  tata: tataLogo,
  union: unionLogo,
  motilal: motilalLogo,
  sbi: sbiLogo,
};

export const getFundLogo = (fundName = "") => {
  const normalized = fundName.toLowerCase();

  const [, matchedLogo] =
    Object.entries(logoMap).find(([key]) => normalized.includes(key)) || [];

  return matchedLogo || null; // Return null if no logo found, instead of defaulting to quant
};

export default getFundLogo;

